export class SessionUserInfoModel {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  personalEmail?: string;
  personalPhone?: number;
  membershipType?: string;
  membershipName?: string;
  membershipId?: string;
  companyId?: string;
  companyName?: string;

  public get displayName() {
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.middleName} ${this.lastName}`;
    }
    else if (this.personalEmail) {
      let part1 = this.personalEmail.split("@")[0];
      return part1.replace("-", " ").replace("_", " ").replace(".", " ");
    }
    else {
      return "";
    }
  }
} 
